<template>
  <div v-if="banks" class="mx-auto">
    <staff-ncs-training-question-bank-view :ncstraining="ncstraining" :banks="banks" v-if="mode==='VIEW'" @edit-bank="onEditBank"/>
    <staff-ncs-training-question-bank-edit :bank="bank" v-else @mode-change="mode='VIEW'"/>
  </div>
</template>
<script>
import { } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import QuestionBank from '@/models/QuestionBank'
import StaffNcsTrainingQuestionBankView from './StaffNcsTrainingQuestionBankView.vue'
import StaffNcsTrainingQuestionBankEdit from './StaffNcsTrainingQuestionBankEdit.vue'
export default {
  components: { StaffNcsTrainingQuestionBankView, StaffNcsTrainingQuestionBankEdit },
  name: 'StaffNcsTrainingQuestionBank',
  props: ['ncstraining', 'ncsLectureCode'],
  data: () => ({
    TAG: 'StaffNcsTrainingQuestionBank',
    mode: 'VIEW',
    bank: undefined,
    banks: {}
  }),
  methods: {
    onBack () {
      this.$router.back()
    },
    count (code) {
      if (!this.banks[code]) return 0
      return this.banks[code].questions.length
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      console.log('')
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      console.log('')
    },
    onEditBank (bank) {
      this.mode = 'EDIT'
      this.bank = bank
    },
    async load () {
      const query = {
        org: this.ncstraining.org._id,
        ncsTrainingCode: this.ncstraining.code
      }
      this.banks = await QuestionBank.list(query)
      this.banks = this.banks.reduce((acc, b) => {
        acc[b.unitCode] = b
        return acc
      }, {})
    }
  },
  created () {
    this.load()
  }
}
</script>
